// List of connected Supabase projects. Click to drill into schema.
// Consumers set `__remoteBasePath` on this picker so cards route
// inside the right URL space (gov: /data/external, CMS: /tables).

export const RemoteProjectPicker = {
  hide: (el, s) => !!el.call('parseRemotePath').slug,
  flow: 'y',
  gap: 'A',

  Hint: {
    tag: 'p',
    fontSize: 'Z2',
    color: 'caption',
    margin: '0',
    text: 'External Supabase projects connected to this org. Click a project to browse its schema and rows.'
  },

  EmptyState: {
    hide: (el, s) => (s.root?._extProjects || []).length > 0 || s.root?._extLoading,
    padding: 'C',
    round: 'Z1',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'dashed',
    borderColor: 'line',
    textAlign: 'center',
    flow: 'y',
    gap: 'Z1',
    Title: {
      tag: 'h2',
      fontSize: 'B',
      color: 'title',
      margin: '0',
      text: 'No external projects connected yet'
    },
    Subtitle: {
      tag: 'p',
      fontSize: 'Z2',
      color: 'caption',
      margin: '0',
      text: 'Connect aihouse, hotcard, benefits, or any Supabase project to make its data browsable here.'
    },
    CTA: {
      tag: 'button',
      type: 'button',
      padding: 'Z A',
      round: 'Y',
      background: 'blue',
      color: 'white',
      fontSize: 'Z2',
      fontWeight: '700',
      cursor: 'pointer',
      border: 'none',
      text: 'Connect a project',
      margin: 'Z1 auto 0',
      onClick: (e, el) => {
        const root = el.call('findRouteRoot', el) || el.getRoot()
        if (root) el.router('/admin/integrations/supabase', root)
      }
    }
  },

  LoadingState: {
    hide: (el, s) => !s.root?._extLoading,
    padding: 'C',
    textAlign: 'center',
    color: 'caption',
    fontSize: 'Z2',
    text: 'Loading connected projects…'
  },

  ProjectCards: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: 'A',
    childExtends: 'RemoteProjectCard',
    childrenAs: 'state',
    children: (el, s) => s.root?._extProjects || []
  }
}
